import { type ID, selectBlocksByNode } from '@octopus-do/octopus-project-core'
import type React from 'react'
import { useSelector } from 'react-redux'

import css from '../../../../../ArtBoard/Node/Node.module.scss'
import { BlocksList } from './BlocksList'

type BlocksType = {
  nodeId: string
  blockId?: ID
}

export const Blocks: React.FC<BlocksType> = ({ nodeId, blockId }) => {
  const ids = useSelector(selectBlocksByNode(nodeId))

  return (
    <div className={css.blocks}>
      {ids.length > 0 && <BlocksList ids={ids} blockId={blockId} />}
    </div>
  )
}
